import React from 'react'

import { useSatuEventTracker } from 'utils/satuEvent'
import { useAuth } from 'utils/auth'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { usePenilikStatus } from './useSummary'

const SATU_EVENT_NAME: string = 'pengkin_penilik_interaction_v1'
const DEFAULT_TIMEOUT: number = 5_000 // 5 seconds

const convertToKeyValuePairs = (
  obj: Record<string, any>
): { key: string; value: any }[] => {
  return Object.entries(obj).map(([key, value]) => ({
    key,
    value,
  }))
}

export const usePenilikTrackEvent = (providedSkpPenilikId: string = '') => {
  const { session } = useAuth()
  const { SETrackEvent } = useSatuEventTracker()
  const { period } = usePeriodContext()

  const {
    summary: penilikSummary,
    summaryFetchStatus: penilikSummaryFetchStatus,
  } = usePenilikStatus({
    disabled: Boolean(providedSkpPenilikId),
  })

  const skpId: string = React.useMemo((): string => {
    if (
      penilikSummaryFetchStatus === 'success' &&
      Boolean(penilikSummary?.skpId)
    ) {
      return penilikSummary.skpId
    }
    return null
  }, [penilikSummary?.skpId, penilikSummaryFetchStatus])

  const trackEventBase = (
    eventCategory: string,
    eventAction: string,
    additionalParams: Record<string, any> = {}
  ): void => {
    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        attributes: convertToKeyValuePairs({
          eventCategory,
          eventAction,
        }),
        custom_dimension: convertToKeyValuePairs({
          ...(!additionalParams?.email_ks && {
            email: session?.user?.email ?? null,
          }),
          periode_id: period.id,
          ...additionalParams,
        }),
      },
      timeout: DEFAULT_TIMEOUT,
      keepAlive: true,
      sendAttributes: false,
    })
  }

  const trackEvent = (
    eventCategory: string,
    eventAction: string,
    additionalParams?: Record<string, any>
  ): void => {
    trackEventBase(eventCategory, eventAction, {
      ...additionalParams,
      skp_id: providedSkpPenilikId || skpId,
    })
  }

  return {
    trackEventBase,
    trackEvent,
  }
}
